import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../services/AuthContext';
import { DEPLOY_EVENTS } from '../../services/deployResilience';

const MAINTENANCE_NOTICE_ID = 'ucp-deploy-maintenance';

/**
 * Toast persistant pendant redeploy / panne gateway, puis confirmation de reprise.
 */
export default function DeployMaintenanceNotice() {
  const { user, pushNotification, dismissNotification } = useAuth();
  const { t } = useTranslation();
  const endedRef = useRef(false);

  useEffect(() => {
    if (!user) return undefined;
    endedRef.current = false;

    const onStart = () => {
      endedRef.current = false;
      pushNotification({
        id: MAINTENANCE_NOTICE_ID,
        type: 'info',
        title: t('toast.deployMaintenanceTitle'),
        message: t('toast.deployMaintenanceMessage'),
        persistent: true,
      });
    };

    const onEnd = () => {
      if (endedRef.current) return;
      endedRef.current = true;
      dismissNotification(MAINTENANCE_NOTICE_ID);
      pushNotification({
        id: `ucp-deploy-ended-${Date.now()}`,
        type: 'success',
        title: t('toast.connectionRestored'),
        message: t('toast.deployMaintenanceEnded'),
        duration: 6000,
      });
    };

    window.addEventListener(DEPLOY_EVENTS.MAINTENANCE_START, onStart);
    window.addEventListener(DEPLOY_EVENTS.MAINTENANCE_END, onEnd);

    return () => {
      window.removeEventListener(DEPLOY_EVENTS.MAINTENANCE_START, onStart);
      window.removeEventListener(DEPLOY_EVENTS.MAINTENANCE_END, onEnd);
      dismissNotification(MAINTENANCE_NOTICE_ID);
    };
  }, [user, pushNotification, dismissNotification, t]);

  return null;
}
